import { useFormik } from 'formik';
import * as yup from 'yup';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid, TextField } from '@mui/material';

import { CustomerDocumentType } from '@/types';
import { useUpdateCustomerDocumentTypeMutation } from '@/services';
import { messages } from '@/utils/helpers';

export interface UpdateCustomerDocumentTypeProps extends DialogProps {
  customerDocumentType: CustomerDocumentType;
  onClose(): void;
}

const UpdateCustomerDocumentType: React.FC<UpdateCustomerDocumentTypeProps> = ({
  customerDocumentType,
  onClose,
  ...props
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const [updateCustomerDocumentType, updateCustomerDocumentTypeResponse] = useUpdateCustomerDocumentTypeMutation();

  const { values, errors, touched, handleSubmit, handleChange } = useFormik<CustomerDocumentType>({
    initialValues: customerDocumentType ?? {
      name: '',
    },
    enableReinitialize: true,
    validationSchema: yup.object().shape({
      name: yup.string().required(messages.form.REQUIRED),
    }),
    async onSubmit(customerDocumentType, { resetForm }) {
      try {
        await updateCustomerDocumentType(customerDocumentType).unwrap();

        onClose();
        resetForm();
      } catch (error) {
        enqueueSnackbar(error.data, { variant: 'error' });
      }
    },
  });

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">Редактировать документ</DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                name="name"
                label="Наименование"
                placeholder="Введите значение"
                value={values.name}
                onChange={handleChange}
                disabled={updateCustomerDocumentTypeResponse.isLoading}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name ? errors.name : ''}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            type="button"
            color="secondary"
            variant="outlined"
            disabled={updateCustomerDocumentTypeResponse.isLoading}
            onClick={onClose}
          >
            Закрыть
          </Button>

          <Button type="submit" variant="contained" disabled={updateCustomerDocumentTypeResponse.isLoading}>
            Редактировать
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default UpdateCustomerDocumentType;
